import React from "react";
import Swiper from "react-id-swiper";

class ChoicePays extends React.Component {
  render() {
    const params = {
      effect: "coverflow",
      grabCursor: true,
      initialSlide: 0,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      slidesPerView: 3,
      pagination: {},
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1.43,
        slideShadows: false
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        360: {
          slidesPerView: 1,
          coverflowEffect: {
            depth: 50,
            modifier: 0
          }
        },
        640: {
          slidesPerView: 3,
          coverflowEffect: {
            depth: 80,
            modifier: 0
          }
        }
      }
    };

    return (
      <section id="choicepays" className="theme-bg-choicepays screenshots">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title">
                <h2>
                  <a 
                    href="https://choicepays.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-white"
                  >
                    Choice Pays
                  </a>
                </h2>
                <p className="text-white">(hired)</p>
                <img
                  src="https://cdn.johnbernazzani.com/white-line.svg"
                  alt="title-line"
                  className="img-fluid title-line"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <img
                src="https://cdn.johnbernazzani.com/mockups/choicepays/mockup_1.png"
                className="img-fluid"
                alt="1"
              />
            </div>
            <div className="col-sm-12 mt-3">
              <img
                src="https://cdn.johnbernazzani.com/mockups/choicepays/mockup_2.png"
                className="img-fluid"
                alt="1"
              />
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center app-description">
              <h1>
                <i className="fa fa-desktop" /> + <i className="fa fa-mobile" />
              </h1>
              <p>
                A healthcare financing platform used by multiple bank partners, tested weekly for compliance, and has processed over $3 million in loan payments without a single missed payment or interest calculation error:
              </p>
              <p>
                React web app for consumers to apply for financing directly from the doctor’s office. Full form application, text message invitation system, and an eSign and DocuSign compatible loan contracts.
              </p>
              <p>
                React Native mobile app for loan applications.
              </p>
              <p>
                A payment processing web app for the company’s customer support team. This React app allowed the team to make one-time payments on behalf of consumers, set up recurring monthly debit card and ACH bank payments, view a consumer’s credit profile and loan payment history.
              </p>
              <p>
                A consumer dashboard web app that allows users to make payments and manage their loans.
              </p>
              <a
                href="https://choicepays.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">Learn More</button>
              </a>
            </div>
          </div>
          <div className="row crafted-with">
            <div className="col-12 text-center">
              <p>Crafted with</p>
            </div>
          </div>
          <div className="row tech-stack d-flex flex-row justify-content-center">
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/react.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/bootstrap.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/node.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/mongodb.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/postgresql.png" alt="1" />
            </div>
            <div className="tech-card d-flex align-items-center">
              <img src="https://cdn.johnbernazzani.com/aws.png" alt="1" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ChoicePays;



// WEBPACK FOOTER //
// ./src/components/choicepays.js